import * as types from "./types";

export const fetchingCircleDetails = (id) => ({
  type: types.FETCHING_CIRCLE_DETAILS,
  loading: true,
  circle_id: id
}); 

export const fetchedCircleDetails=(circle, id)=>({
  type: types.FETCHED_CIRCLE_DETAILS,
  circle: circle,
  loading: false,
  circle_id: id
});

export const errorFetchingCircleDetails = (error) => ({
  type: types.ERROR_FETCHING_CIRCLE_DETAILS,
  error: error,
  loading: false
});